import { useEffect, useState } from "react";
import IdleTimer from "react-idle-timer";
import { BrowserRouter as Router } from "react-router-dom";

import jwtDecode from "jwt-decode";
import {
  Redirect,
  Route,
  Switch,
} from "react-router-dom/cjs/react-router-dom.min.js";
import { encryptStorage } from "../../constants/EncryptStorage";
import UpdateToken from "../../UpdateToken";
import EventSpecialAttendanceCase from "../events/EventSpecialAttendanceCase.js";
import LoginSignUp from "../loginSignUp/LoginSignUp";
import Logout from "../logout/Logout";
import Layout from "../shared/Layout.js";
import { LoadingSpinner } from "../../constants/const.js";
import { GetLanguageString } from "../helper/Components.js";
import EventSummaryReport from "../events/report/EventSummaryReport/EventSummaryReport.js";

const tokenString = encryptStorage.getItem("token");
let localToken = "";
if (tokenString !== undefined) localToken = tokenString;

const LoginRedirect = () => {
  const [values, setValues] = useState({ token: "" });
  const [doLogout, setDoLogout] = useState(false);
  const [responsibilityChangeLoading, setResponsibilityChangeLoading] =
    useState(false);
  const eventId = encryptStorage.getItem("attendanceAccessEventId");
  const attendanceAccess = !!eventId && eventId !== "0";

  const [isTokenExist, setIsTokenExist] = useState(false);
  useEffect((values) => {
    setValues({
      ...values,
      token: localToken,
    });
    setIsTokenExist(true);
  }, []);

  if (!isTokenExist) {
    return null;
  }

  if (!values.token) {
    return <LoginSignUp setValues={setValues} />;
  }

  if (values.token) {
    let token = jwtDecode(values.token);
    let tokenTime = new Date(token.exp * 1000);
    tokenTime.setMinutes(tokenTime.getMinutes() + 1);
    const currentTime = new Date();
    if (tokenTime < currentTime) {
      return <Logout setDoLogout={setDoLogout} />;
    }
  }

  const handleOnIdle = (event) => {
    setDoLogout(true);
  };
  return (
    <Router>
      <IdleTimer timeout={1000 * 60 * 15} onIdle={handleOnIdle} />
      <UpdateToken setDoLogout={setDoLogout} />

      {doLogout ? (
        <Logout setDoLogout={setDoLogout} />
      ) : attendanceAccess && !responsibilityChangeLoading ? (
        <Switch>
          {/* Main attendance route */}
          <Route exact path="/barCodeAttendance">
            <EventSpecialAttendanceCase
              setResponsibilityChangeLoading={setResponsibilityChangeLoading}
            />
          </Route>

          {/* Summary report */}
          <Route exact path="/eventReports/summaryReport">
            <div
              style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                background: "linear-gradient(135deg, #f8fafc, #e2e8f0)",
                overflow: "auto",
                transition: "background 0.4s ease",
              }}
            >
              <EventSummaryReport />
            </div>
          </Route>

          {/* Redirect everything else to attendance */}
          <Redirect to="/barCodeAttendance" />
        </Switch>
      ) : attendanceAccess && responsibilityChangeLoading ? (
        <div
          className="text-center"
          style={{
            backgroundColor: "white",
            width: "100vw",
            height: "100vh",
          }}
        >
          <br />
          <h2>{<GetLanguageString props={"responsibility_change_text"} />}</h2>
          {LoadingSpinner()}
        </div>
      ) : (
        <Switch>
          {/* Normal app layout */}
          <Route path="/">
            <Layout />
          </Route>
        </Switch>
      )}
    </Router>
  );
};

export default LoginRedirect;
